import bridges1 from "../../assets/MediaGallery/Bridges/1.png";
import bridges2 from "../../assets/MediaGallery/Bridges/2.png";
import bridges3 from "../../assets/MediaGallery/Bridges/3.png";
import bridges4 from "../../assets/MediaGallery/Bridges/4.png";
import bridges5 from "../../assets/MediaGallery/Bridges/5.png";
import bridges6 from "../../assets/MediaGallery/Bridges/6.png";
import bridges7 from "../../assets/MediaGallery/Bridges/7.png";
import bridges8 from "../../assets/MediaGallery/Bridges/8.png";
import bridges9 from "../../assets/MediaGallery/Bridges/9.png";
import bridges10 from "../../assets/MediaGallery/Bridges/10.png";
import bridges11 from "../../assets/MediaGallery/Bridges/16.png";
import bridges12 from "../../assets/MediaGallery/Bridges/17.png";
import railway13 from "../../assets/MediaGallery/Railway/11.png";
import railway14 from "../../assets/MediaGallery/Railway/12.png";
import railway15 from "../../assets/MediaGallery/Railway/13.png";
import railway16 from "../../assets/MediaGallery/Railway/18.png";
import railway17 from "../../assets/MediaGallery/Railway/19.png";
import railway18 from "../../assets/MediaGallery/Railway/20.png";
import railway19 from "../../assets/MediaGallery/Railway/21.png";
import plant20 from "../../assets/MediaGallery/Water Treatment Plant/14.png";
import plant21 from "../../assets/MediaGallery/Water Treatment Plant/15.png";

export const galleryItems = [
  {
    id: 1,
    category: "bridges",
    image: bridges1,
    title: "GUWAHATI Project",
  },
  {
    id: 2,
    category: "bridges",
    image: bridges2,
    title: "GUWAHATI Project",
  },
  {
    id: 3,
    category: "bridges",
    image: bridges3,
    title: "GARFA Project",
  },
  {
    id: 4,
    category: "bridges",
    image: bridges4,
    title: "GARFA Project",
  },
  {
    id: 5,
    category: "bridges",
    image: bridges5,
    title: "BHADRAK Project",
  },
  {
    id: 6,
    category: "bridges",
    image: bridges6,
    title: "BHADRAK Project",
  },
  {
    id: 7,
    category: "bridges",
    image: bridges7,
    title: "KAMARKUNDU Project",
  },
  {
    id: 8,
    category: "bridges",
    image: bridges8,
    title: "KAMARKUNDU Project",
  },
  {
    id: 9,
    category: "bridges",
    image: bridges9,
    title: "BAMANGACHI Project",
  },
  {
    id: 10,
    category: "bridges",
    image: bridges10,
    title: "BAMANGACHI Project",
  },
  {
    id: 11,
    category: "bridges",
    image: bridges11,
    title: "SHIKARIPARA Project",
  },
  {
    id: 12,
    category: "bridges",
    image: bridges12,
    title: "SHIKARIPARA Project",
  },
  {
    id: 13,
    category: "railways",
    image: railway13,
    title: "NAMAK GOLA GHAT Project",
  },
  {
    id: 14,
    category: "railways",
    image: railway14,
    title: "NAMAK GOLA GHAT Project",
  },{
    id: 15,
    category: "railways",
    image: railway15,
    title: "NAMAK GOLA GHAT Project",
  },{
    id: 16,
    category: "railways",
    image: railway16,
    title: "NIDHIPANDA Project",
  },{
    id: 17,
    category: "railways",
    image: railway17,
    title: "NIDHIPANDA Project",
  },{
    id: 18,
    category: "railways",
    image: railway18,
    title: "JAIRAMBATI Project",
  },
  {
    id: 19,
    category: "railways",
    image: railway19,
    title: "JAIRAMBATI Project",
  },
  {
    id: 20,
    category: "plant",
    image: plant20,
    title: "JAIRAMBATI Project",
  },
  {
    id: 21,
    category: "plant",
    image: plant21,
    title: "JAIRAMBATI Project",
  },
]